/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Web_Card1_SubInputs */

const tr_landing_web_card1_sub = /** @type {(inputs: Landing_Web_Card1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bölümleri taşıyın, yazıyı ve görseli değiştirin, sonucu anında yan tarafta görün. Tek satır kod yazmadan.`)
};

const en_landing_web_card1_sub = /** @type {(inputs: Landing_Web_Card1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move sections, change text and images, see the result right next to you. Without a single line of code.`)
};

const de_landing_web_card1_sub = /** @type {(inputs: Landing_Web_Card1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereiche verschieben, Texte und Bilder ändern, das Ergebnis sofort daneben sehen. Ohne eine Zeile Code.`)
};

const ru_landing_web_card1_sub = /** @type {(inputs: Landing_Web_Card1_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переставляйте блоки, меняйте тексты и картинки, результат виден сразу рядом. Без единой строки кода.`)
};

/**
* | output |
* | --- |
* | "Move sections, change text and images, see the result right next to you. Without a single line of code." |
*
* @param {Landing_Web_Card1_SubInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_web_card1_sub = /** @type {((inputs?: Landing_Web_Card1_SubInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Web_Card1_SubInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_web_card1_sub(inputs)
	if (locale === "de") return de_landing_web_card1_sub(inputs)
	if (locale === "ru") return ru_landing_web_card1_sub(inputs)
	return tr_landing_web_card1_sub(inputs)
});